import fetchServer from "../fetchServer";

export default async function ocrTravelerDocument(fileOrFormData, onUploadProgress) {
  let result = { return: 0, msg: "Error", data: {} };

  let data = fileOrFormData;
  if (typeof File !== "undefined" && fileOrFormData instanceof File) {
    data = new FormData();
    data.append("file", fileOrFormData);
  }

  await fetchServer({
    method: "POST",
    url: "/product/v1/misc/ocr/traveler-document",
    data,
    onUploadProgress,
  })
    .then((res) => {
      if (res) {
    if (res?.status >= 200 && res?.status < 300) {
          result = {
            return: 1,
            msg: "Successfull",
            data: res.data?.data ?? res.data,
          };
        } else if (res?.data?.error) {
          result.msg = res.data.error;
        } else if (res?.message) {
          result.msg = res.message;
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}
